import { Component, inject, input, output } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { waremaComToolOverviewUrl } from '@warema/shared/constants';
import { Dictionary, ENVIRONMENT, IAppConfig, SharedHeaderEnvironment } from '@warema/shared/models';
import { WaremaHeaderMenuItem } from '@warema/warema-ui-angular';

@Component({
    selector: 'warema-shared-header-submenu-tools',
    imports: [TranslatePipe, RouterLink, WaremaHeaderMenuItem],
    templateUrl: './shared-header-submenu-tools.component.html',
    styleUrl: './shared-header-submenu-tools.component.scss',
})
export class SharedHeaderSubmenuToolsComponent {
    public readonly translateService = inject(TranslateService);
    private readonly _environment = inject<SharedHeaderEnvironment>(ENVIRONMENT);

    public readonly appName = input.required<'warema-collection-assistant' | 'warema-designer-web' | 'warema-plus'>();

    public readonly firstRouteSegment = input('');

    public readonly hideShopLinks = input(false);

    public readonly tenantConfigSettings = input.required<IAppConfig | null>();

    public readonly clickUrl = output<string>();

    public readonly clickRouteRedirect = output<string>();

    public getUrl(
        app: 'warema-collection-assistant' | 'warema-designer-web' | 'warema-plus' | 'warema-com-tool-overview',
        subRoute: string | null = null,
    ): string {
        let returnUrl = app === 'warema-com-tool-overview' ? '' : this._environment.toolUrls[app];
        if (subRoute != null) {
            returnUrl += `/${subRoute}`;
        }

        const [currentLang, currentCountry] = this.translateService.getCurrentLang().split('-');
        if (currentLang == null) {
            return returnUrl;
        }

        const fallbackCountries: Dictionary<string> = {
            sv: 'SE',
        };
        const fallbackCountry = fallbackCountries[currentLang] ?? currentLang.toUpperCase();
        const newCountryKey = currentCountry ?? fallbackCountry;

        if (app === 'warema-com-tool-overview') {
            returnUrl = (waremaComToolOverviewUrl[currentLang] ?? '').replace(
                '{{ country }}',
                newCountryKey.toLowerCase(),
            );
        } else if (currentLang !== 'de') {
            if (app === 'warema-plus') {
                returnUrl += `?lang=${currentLang}-${newCountryKey}`;
            } else {
                returnUrl += `?language=${currentLang}`;
            }
        }

        return returnUrl;
    }
}
